import { Button, Card, makeStyles, Tabs, Tab } from '@material-ui/core'
import React from 'react'
import ReactAudioPlayer from 'react-audio-player';
import { TabContext, TabPanel } from '@material-ui/lab';

import { useStyles } from './styles'
import Backdrop from '../../../../components/Modal/Backdrop';
import Modal from '../../../../components/Modal/Modal';
import Fileupload from './Fileupload';
import RecordAudio from './RecordAudio';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';
const muiTheme = createMuiTheme({});


const useStyleses = makeStyles(
    (theme: any) => {
        return {
            root: {
                [theme.breakpoints.down('sm')]: {
                    width: '100%'
                },
            },
            loopIcon: {
                color: '#4D72F8',
                '&.selected': {
                    color: '#0921a9'
                },
                '&:hover': {
                    color: '#4D72F8'
                },
                [theme.breakpoints.down('sm')]: {
                    display: 'none'
                }
            },
            playIcon: {
                color: '#4D72F8',
                fontSize: '28px',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            pauseIcon: {
                color: '#4D72F8',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            volumeIcon: {
                color: '#4D72F8',
                fontSize: '28px',
                '&:hover': {
                    color: '#4D72F8'
                }
            },
            volumeSlider: {
                color: '#4D72F8'
            },
            progressTime: {
                color: '#6b6b6d'
            },
            mainSlider: {
                color: '#4D72F8',
                '& .MuiSlider-rail': {
                    color: '#4D72F8'
                },
                '& .MuiSlider-track': {
                    color: '#4D72F8'
                },
                '& .MuiSlider-thumb': {
                    color: '#4D72F8'
                }
            }
        }
    });

function DepartmentsGreetingCard(props: any) {
    const [srcss, setSrcss] = React.useState<any>('')
    const [value, setValue] = React.useState("2");
    const [editUds, seteditUds] = React.useState(false)
    const classes = useStyles()
    const handleLoadMetadata = (meta: any) => {
        const { duration } = meta.target;
        const styles = makeStyles({

        })
        // console.log(duration);
    }
    const handlePopupModalAdd = () => {
        seteditUds(!editUds)
    }
    const handleChange = (event: React.ChangeEvent<{}>, newValue: any) => {
        setValue(newValue);
    };
    return (
        <div>
            {
                editUds && (
                    <div>
                        <Backdrop handlePopupModal={handlePopupModalAdd} />
                        <Modal title='Edit Users & Departments' handlePopupModal={handlePopupModalAdd} >
                            <div className={classes.editmodal}>
                                <Tabs
                                    value={value}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    className={classes.tabs}
                                    onChange={handleChange}
                                    id="editVoiceMailTab"
                                >
                                    {/* <Tab
                                        label="Record Audio"
                                        value="1"
                                        className={value === "1" ? classes.tabActive : classes.tab}
                                    /> */}
                                    <Tab
                                        label="Upload Audio"
                                        value="2"
                                        className={value === "2" ? classes.tabActive : classes.tab}
                                    />

                                </Tabs>
                                <TabContext value={value}>
                                    <TabPanel value="1">
                                        <RecordAudio openHrFiles={props.soundFiles} />
                                    </TabPanel>
                                    <TabPanel value="2">
                                        <Fileupload data={props.data} depId={props.depId}
                                            getOpenHours={props.getOpenHours} />
                                    </TabPanel>
                                </TabContext>
                            </div>
                        </Modal>
                    </div>
                )
            }

            <div>
                <div className={classes.audioContainer}>
                    <div>
                        <ReactAudioPlayer
                            controls
                            // className={classes.audioPlayer}
                            onLoadedMetadata={handleLoadMetadata}
                            src={props.voiceData}
                            className={classes.audioPlayers}
                        />
                        <span className={classes.filename}>{props.voiceName}</span>
                    </div>
                    <Button className={classes.editbtn} onClick={handlePopupModalAdd}>
                        Edit
                    </Button>
                </div>

            </div>
        </div>
    )
}

export default DepartmentsGreetingCard